import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login.vue"),
  },
  {
    path: "/admin",
    name: "adminDashboard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/admin/dashboard"),
    meta: {
      permission: "admin",
    },
  },
  {
    path: "/admin/insurances",
    component: () =>
      import(
        /* webpackChunkName: "insurance" */ "../views/admin/insuranceList"
      ),
    meta: {
      permission: "admin",
    },
  },
  {
    path: "/admin/completeInsurances",
    component: () =>
      import(
        /* webpackChunkName: "completeInsurance" */ "../views/admin/completeInsuranceList"
      ),
    meta: {
      permission: "admin",
    },
  },
  {
    path: "/admin/admins",
    component: () =>
      import(/* webpackChunkName: "admins" */ "../views/admin/adminList"),
    meta: {
      permission: "admin",
    },
  },
  {
    path: "*",
    component: HomeView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
